import React from 'react'

export interface ErrorReport {
  error: Error
  errorInfo: React.ErrorInfo
  timestamp: string
  boundary: 'app' | 'route'
  pathname: string
}

export type ErrorReportCallback = (report: ErrorReport) => void

let callback: ErrorReportCallback | null = null

const errorReporter = {
  setCallback(cb: ErrorReportCallback): void {
    callback = cb
  },

  report(error: Error, errorInfo: React.ErrorInfo, boundary: 'app' | 'route'): void {
    const report: ErrorReport = {
      error,
      errorInfo,
      timestamp: new Date().toISOString(),
      boundary,
      pathname: window.location.pathname,
    }

    // Always log to console
    console.error(`[ErrorBoundary:${boundary}]`, error, errorInfo.componentStack)

    // Call external callback if registered
    if (callback) {
      try {
        callback(report)
      } catch (callbackError) {
        console.warn('[ErrorBoundary] Error reporter callback failed:', callbackError)
      }
    }
  },
}

export default errorReporter
